import React, { Component } from 'react';
import styled from 'styled-components';

const Bar = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  z-index: 20;

  background-color: ${props => props.theme.color.primary};
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;

  color: ${props => props.theme.color.tertiary};
  font-size: 16px;

  height: 50px;
  width: 100%;

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 0;
  }

  &>p {
    margin: 0;
    text-align: center;
    font-family: ${props => props.theme.font.metaDt};
    font-family: 'Merriweather Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
  }

  & a {
    color: ${props => props.theme.color.tertiary};
    text-decoration: underline dotted;
  }
`;

class SoftLaunchBar extends Component {
  render() {
    return (
      <Bar>
        <p><strong>Coming Soon!</strong> New and Improved Website Experience.</p>
        <p><a href="https://preview.lochinvar.com/">Preview the New Look</a></p>
      </Bar>
    );
  }
}

export default SoftLaunchBar;
